import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActionResult, apiResourceActionCreator } from '../../common';
import { authTokenSelector } from '../../session';
import getCpdCategorysConfig from './getCpdCategorys';
import { apiAction as setCpdCategorysApiAction, default as setCpdCategorysConfig } from './setCpdCategorys';

const actions = createActions({
  USER: {
    API: {
      SET_TRAINING_PLAN: apiResourceActionCreator('cpdCategorys')
    },
    SET_TRAINING_PLAN: (payload) => (payload)
  }
})

export function* setTrainingPlan(action) {
  const authToken = yield select(authTokenSelector);

  if (authToken.idToken) {
    yield put(setCpdCategorysApiAction(authToken, {
      industryId: action.payload.industryId,
      pendingCpdCategorys: action.payload.cpdCategorys
    }));

    const setCpdCategorysResult = yield apiActionResult(setCpdCategorysConfig.action.user.api.setCpdCategorys);

    if (setCpdCategorysResult) {
      yield put(getCpdCategorysConfig.action.user.getCpdCategorys(action.payload.industry.userId));
    }
  }
}

const configuration = {
  name: 'setTrainingPlan',
  action: actions,
  sagas: setTrainingPlan,
  reducers: {

  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/setTrainingPlan.js